import { render } from "./payments-page.vue?vue&type=template&id=e500204a&scoped=true"
import script from "./payments-page.vue?vue&type=script&lang=js"
export * from "./payments-page.vue?vue&type=script&lang=js"

import "./payments-page.vue?vue&type=style&index=0&id=e500204a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e500204a"]])

export default __exports__